import { NotificationRule } from '@eppendorf/vnls-notifications-utils';
import {
  Badge,
  HasClassName,
  Icon,
  IconSizeClasses,
} from '@eppendorf/vnls-react-components';
import { useTranslation } from 'react-i18next';

import { FeatureIsEnabled } from '$components/feature-toogle/feature-is-enabled';
import { PauseNotificationRuleToggle } from '$features/notifications/pause-notification-rule-toggle';

import stylesHeader from './notification-detail-header.module.scss';
import styles from './notification-detail.module.scss';

export interface NotificationRuleDetailHeaderProps extends HasClassName {
  notificationRule: NotificationRule;
  showNotificationRuleStatus?: boolean;
}

export function NotificationDetailHeader({
  className: _,
  notificationRule,
  showNotificationRuleStatus = true,
}: NotificationRuleDetailHeaderProps) {
  const { t } = useTranslation();

  const isPaused = notificationRule.paused ?? false;

  const statusBadge = showNotificationRuleStatus ? (
    <Badge color={isPaused ? 'orange' : 'green'} bordered>
      {t(isPaused ? 'notificationRules.paused' : 'notificationRules.active')}
    </Badge>
  ) : null;

  return (
    <>
      <div className={styles.notificationDetailHeader}>
        <div className={styles.notificationDetailTitle}>
          <h2 className="title">{notificationRule.name}</h2>
        </div>
        <div className={`${styles.notificationDetailBadge} flex flex__ai--center gap-s`}>
          <FeatureIsEnabled
            feature="ESEVNLS_4578_PASUSE_NOTI_RULES"
            fallback={statusBadge}
          >
            <PauseNotificationRuleToggle notificationRule={notificationRule} bordered />
          </FeatureIsEnabled>
        </div>
      </div>

      {isPaused && (
        <FeatureIsEnabled feature="ESEVNLS_4578_PASUSE_NOTI_RULES">
          <div className={stylesHeader.pausedHeader}>
            <Icon
              name="warning"
              size={IconSizeClasses.XSmall}
              className="bg-orange-500"
            />
            <div className="flex flex__dir--column">
              <p>{t('notificationRules.pausedHintDescription')}</p>
            </div>
          </div>
        </FeatureIsEnabled>
      )}
    </>
  );
}
